import { Container, Modal } from "react-bootstrap";
import PrimaryButton, {
  SecondaryButton,
} from "../../../util/Btns/PrimaryButton";
import arrowdown from "../../../Assets/arrowdown.svg";

import Close from "../../../Assets/close.svg";
import styles from "./InviteMemberModal.module.scss";
import { useEffect, useState } from "react";
import { useInviteUser } from "../../../hooks/DevAuthHooks";
import { CustomToast } from "../../../util/custom-toast/CustomToast";
import ConsoleLocalStorage from "../../../storage/storage";
// import { useDeleteBuild } from "../../../hooks/DevAppHooks";

const RemoveMember = ({ showInviteMember, setShowInviteMember }) => {
  const [email, setEmail] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showError, setShowError] = useState(false);
  const [role, setRole] = useState("Select Role");
  const handleClose = () => setShowInviteMember(false);
  const { mutate } = useInviteUser(setShowInviteMember);
  const handleSubmit = () => {
    if (!validateEmail(email)) {
      CustomToast("Invalid Email");
      return;
    }
    const data = { email: email, userType: role, tags: ConsoleLocalStorage.getOrganization().tags || 'consumer' };
    mutate(data);
  };

  const validateEmail = (emailVal) => {
    if(emailVal !== ""){
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(emailVal).toLowerCase());
    }
  }


  String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

useEffect(()=>{
  setEmail("");
},[showInviteMember])

  return (
    <>
      <Container>
        <Modal
          show={showInviteMember}
          onHide={handleClose}
          centered
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Header className={styles.header}>
            <Modal.Title>
              <div style={{ padding: "0.25em" }}>
                <span
                  style={{ fontFamily: "JioType-Medium", fontSize: "medium" }}
                >
                  Invite Member
                </span>
              </div>
            </Modal.Title>

            <img
              onClick={() => setShowInviteMember(false)}
              style={{ marginTop: "15px" }}
              src={Close}
              height="14"
              width="14"
              alt="cross"
              className="cursor-pointer"
            />
          </Modal.Header>

          <Modal.Body>
            <div className={styles.body}>
              <input
                type="email"
                value={email}
                placeholder="Enter Email ID"
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (
                    validateEmail(e.target.value) ||
                    e.target.value.length === 0
                  ) setShowError(false);
                  else if(!validateEmail(e.target.value)){
                    setShowError(true);
                  }
                }}
              />
              {showError && <p className="float-right mb-0 validation-msg">
                      <span className="border-red red">Invalid Email</span>
                    </p>}
              <div className={styles.role}>
                <span>Assign Role</span>

                <div className={styles.rolelist}>
                  <span onClick={() => setShowDropdown(!showDropdown)}>
                    {role.capitalize()} <img src={arrowdown} alt="" />
                  </span>
                  {showDropdown ? (
                    <ul>
                      <li
                        style={{
                          color: `${role === "admin" ? "white" : "#707070"}`,
                        }}
                        onClick={() => {
                          setRole("admin");
                          setShowDropdown(false);
                        }}
                      >
                        Admin
                      </li>
                      <li
                        style={{
                          color: `${
                            role === "developer" ? "white" : "#707070"
                          }`,
                        }}
                        onClick={() => {
                          setRole("developer");
                          setShowDropdown(false);
                        }}
                      >
                        Developer
                      </li>
                      <li
                        style={{
                          color: `${role === "qa" ? "white" : "#707070"}`,
                        }}
                        onClick={() => {
                          setRole("qa");
                          setShowDropdown(false);
                        }}
                      >
                        QA
                      </li>
                    </ul>
                  ) : null}
                </div>
              </div>
              <div className={styles.buttonContainer}>
                <PrimaryButton
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Send Invite
                </PrimaryButton>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default RemoveMember;
